/**
 * Formats the backend's raw `name` field errors into a single user-facing
 * string. Rails-style messages (`"has already been taken"`) get rewritten as
 * fuller sentences; anything we don't recognise falls back to a capitalised
 * field-prefixed string.
 *
 * Shared between `CampaignNameStep` (form input on step 0) and
 * `AddEmailCampaign` (inline title in the wizard header on steps 1+) so the
 * same Redux error surfaces identically in both UIs.
 */
export const formatCampaignNameError = (errors: string[]): string => {
    const first = errors[0];
    if (!first) return 'This name is not valid.';
    if (first.includes('has already been taken')) {
        return 'A campaign with this name already exists.';
    }
    return `Name ${first}`;
};
